// extracted by mini-css-extract-plugin
module.exports = {"container":"ErrorPage_container__37Lfy","errorImg":"ErrorPage_errorImg__3QFqb","errorMsg":"ErrorPage_errorMsg__3m5Iu"};